var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSweden2X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "48px",
    viewBox: "0 0 71 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sweden@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flags",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-662.000000, -682.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.000000, 70.000000)",
    fillRule: "nonzero",
    id: "Sweden"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(592.000000, 612.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rounded_Rectangle_7_copy-52",
    fill: "#4A89DC",
    x: 0.63,
    y: 0.84,
    width: 70,
    height: 47,
    rx: 6.36
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFCE54",
    x: 16.63,
    y: 0.84,
    width: 8,
    height: 47
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle_5_copy-5",
    fill: "#FFCE54",
    points: "0.63 28.84 0.63 20.84 70.63 20.84 70.63 28.84"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSweden2X);
export default __webpack_public_path__ + "static/media/Sweden@2x.c28d7d668366978544844915f9d414ea.svg";
export { ForwardRef as ReactComponent };